<template>
  <ion-toolbar>
    <ion-buttons
      slot="start"
      v-if="
        $store.state.pages.auth.back.length || routeName == 'profile_travel'
      "
    >
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end" v-if="routeName != 'profile_travel'">
      <ion-button class="pill next-pill-button" @click="skip">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Travel Requirements</h1>
        </div>
        <div class="brand-icon">
          <SvgIcon
            name="brandIcon"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          />
        </div>
      </div>
      <el-form
        class="full_page"
        :label-position="'top'"
        @submit.prevent="setStepValue(1)"
      >
        <el-form-item label="Are you willing to work outside metro areas?">
          <el-radio-group v-model="travel.workOutsideMetro">
            <el-radio label="Yes" value="1" />
            <el-radio label="No" value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="Are you willing to stay in regional areas for a short stint (1-4 weeks) where accommodation, meal allowance and travel cost are covered?"
        >
          <el-radio-group v-model="travel.shortStint">
            <el-radio label="Yes" value="1" />
            <el-radio label="No" value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Would you consider anything longer than 4 weeks?">
          <el-radio-group v-model="travel.longTermJob">
            <el-radio label="Yes" value="1" />
            <el-radio label="No" value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Are you fluent in a language other than English?">
          <el-radio-group v-model="language">
            <el-radio label="Yes" value="1" />
            <el-radio label="No" value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item class="button_submit mb0">
          <el-button class="submit" type="blue_light" @click="save(travel)">
            Continue
          </el-button>
        </el-form-item>
      </el-form>
      <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon
          name="bgIcon"
          class="bg-icon"
          width="174"
          height="174"
          viewBox="0 0 174 174"
          fill="none"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject, ref } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter, useRoute } from "vue-router";
import SvgIcon from "@/components/Svg/SvgIcon.vue";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const routeName = $route.name;
    const userData = $store.getters.GET_USER_DATA;
    const travel = ref({
      workOutsideMetro: userData.travel.workOutsideMetro === 1 ? "Yes" : "No",
      shortStint: userData.travel.shortStint === 1 ? "Yes" : "No",
      longTermJob: userData.travel.longTermJob === 1 ? "Yes" : "No",
    });
    // const travel = ref(userData.travel);

    // travel.value = {
    //   workOutsideMetro: "Yes",
    //   shortStint: "No",
    //   longTermJob: "No",
    // };

    const language = ref(userData.settings.languages != null ? "Yes" : "No");

    const goBack = async () => {
      if (routeName == "profile_travel") {
        $router.push({
          name: "profile_edit",
        });
      } else {
        const back = await $store.dispatch("getAuthPageBack");
        $router.push({
          name: back,
        });
      }
    };

    const goNext = () => {
      if (routeName == "profile_travel") {
        $router.push({
          name: "profile_edit",
        });
      } else {
        if (language.value === "Yes") {
          $router.push({
            name: "auth_languages",
          });
        } else {
          $router.push({ name: "identity_document" });
        }
      }
    };

    const skip = () => {
      $store.dispatch("addAuthPageBack", $route.name);
      goNext();
    };

    const save = async (travel) => {
      const travelData = {
        workOutsideMetro: travel.workOutsideMetro === "Yes" ? 1 : 0,
        shortStint: travel.shortStint === "Yes" ? 1 : 0,
        longTermJob: travel.longTermJob === "Yes" ? 1 : 0,
      };

      try {
        await $store.dispatch("SAVE_USER_DATA", {
          travel: travelData,
        });

        goNext();
        // if (language.value === "Yes") {
        //   $router.push({
        //     name: "auth_languages",
        //   });
        // }
      } catch (error) {
        console.log("error submit!!");
      }
    };

    onMounted(() => {
      setPageClassGlobal("global_auth_page");
    });

    return {
      goBack,
      skip,
      save,
      routeName,
      travel,
      language,
    };
  },
};
</script>